import { FormSection } from 'old/components/form-section/form-section'
import { Typography } from 'antd'
import { useTranslate }  from 'old/utils'
import { HorizontalContainer, VerticalContainer } from 'old/components/styled'
import { FormSwitch } from 'old/components/form-inputs'
import { Field, useField } from 'react-final-form'
const { Text, Paragraph } = Typography

export const TeamMemberStatus = () => {

    //translate:
    const { __ } = useTranslate()
    
    //field:
    const { input: { value: status } } = useField('status')

    //render:
    return (
        <FormSection title={__`status`}>

            <VerticalContainer>

                <HorizontalContainer>

                    {/* title */}
                    <Text>

                        {__`team_member_is`}
                        &nbsp;
                        <Text style={{ fontWeight: 'bold' }}>
                            {status ? __`enabled` : __`disabled`}
                        </Text>

                    </Text>

                    {/* switch */}
                    <Field
                        name="status"
                        type="switch"
                        component={FormSwitch}
                    />

                </HorizontalContainer>

                <Paragraph type='secondary' style={{ marginBottom: 0 }}>
                    {status ? __`disable_if_you_want_to_be_temporarily_unavailable` : __`enable_if_you_want_to_be_available`}
                </Paragraph>

            </VerticalContainer>

        </FormSection>
    )

}
